/* ========================================================================== */
/* FREEBIE HIDDEN PRODUCT FILTER                                              */
/* ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  const hiddenHandles = [
    'test-product',
    'protein-sachets-freebie',
    'plant-protein-sachets-freebie-pack-of-2',
    'melatonin-gummies-pack-of-2',
    'melatonin-gummies-sachet-pack-of-1',
    'melatonin-gummies-sachet-freebie',
    'plant-protein-sachets-freebie-pack-of-2'
  ];

  const currentPath = window.location.pathname;

  const isCartPage = currentPath === '/cart';
  const isCartDrawer = !!document.querySelector('#CartDrawer, .cart-drawer, .drawer--cart');
  const isHiddenProductPage = hiddenHandles.some(handle => currentPath === `/products/${handle}`);

  if (!isHiddenProductPage && !isCartPage && !isCartDrawer) {
    function removeHiddenProductTiles() {
      hiddenHandles.forEach(handle => {
        const productPath = `/products/${handle}`;
        document.querySelectorAll(`a[href*="${productPath}"]`).forEach(link => {
          const tile = link.closest(
            'li, article, .grid__item, .product-card, .product-item, .card, .search__result, .predictive-search__item'
          );
          if (tile) tile.remove();
        });
      });
    }

    function observePredictiveSearch() {
      const containers = document.querySelectorAll('[data-predictive-search], .predictive-search');
      containers.forEach(container => {
        const observer = new MutationObserver(removeHiddenProductTiles);
        observer.observe(container, { childList: true, subtree: true });
      });
    }

    removeHiddenProductTiles();
    observePredictiveSearch();
  }
});

/* ========================================================================== */
/* RMV2 TRUNCATION HANDLER                                                    */
/* ========================================================================== */

(function(){
  function setInlineChildren(el){
    if(!el) return;
    Array.prototype.slice.call(el.querySelectorAll('*')).forEach(function(ch){
      ch.style.display = 'inline';
      ch.style.margin = '0';
      ch.style.padding = '0';
    });
  }

  function needsTruncation(previewInner){
    if(!previewInner) return false;
    setInlineChildren(previewInner);
    var width = Math.max(1, Math.round(previewInner.getBoundingClientRect().width));
    var clone = previewInner.cloneNode(true);
    clone.style.position = 'absolute';
    clone.style.visibility = 'hidden';
    clone.style.width = width + 'px';
    clone.style.height = 'auto';
    clone.style.maxHeight = 'none';
    clone.style.display = 'block';
    clone.style.webkitLineClamp = 'unset';
    clone.style.WebkitLineClamp = 'unset';
    clone.style.webkitBoxOrient = 'unset';
    document.body.appendChild(clone);
    var fullH = clone.scrollHeight;
    document.body.removeChild(clone);
    var clampedH = previewInner.getBoundingClientRect().height;
    return fullH > clampedH + 1;
  }

  function initBlock(block){
    if(block.__rmv2) return;
    block.__rmv2 = true;

    var preview = block.querySelector('.rmv2-preview');
    var previewInner = block.querySelector('.rmv2-preview-inner');
    var full = block.querySelector('.rmv2-full');
    var more = block.querySelector('.rmv2-toggle-more');
    var less = block.querySelector('.rmv2-toggle-less');

    if(!preview || !previewInner || !full || !more || !less) return;

    preview.style.display = 'block';
    full.style.display = 'none';
    more.setAttribute('aria-expanded','false');

    function refresh(){
      setInlineChildren(previewInner);
      if(needsTruncation(previewInner)){
        more.style.display = 'block';
      } else {
        more.style.display = 'none';
      }
    }

    more.addEventListener('click', function(e){
      preview.style.display = 'none';
      full.style.display = 'block';
      more.setAttribute('aria-expanded','true');
      e.preventDefault();
    });

    less.addEventListener('click', function(e){
      full.style.display = 'none';
      preview.style.display = 'block';
      more.setAttribute('aria-expanded','false');
      e.preventDefault();
      setTimeout(refresh, 20);
    });

    setTimeout(refresh, 20);

    var t;
    window.addEventListener('resize', function(){
      clearTimeout(t);
      t = setTimeout(refresh, 120);
    });
  }

  function initAll(){
    document.querySelectorAll('.rmv2-block').forEach(initBlock);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

/* ========================================================================== */
/* HIDDEN PAGES FILTER                                                        */
/* ========================================================================== */

document.addEventListener("DOMContentLoaded", function() {
  if (typeof window.hiddenPagesArray === "undefined") return;

  const hiddenHandles = window.hiddenPagesArray;
  if (!hiddenHandles.length) return;

  hiddenHandles.forEach(handle => {
    document.querySelectorAll(`[href*="/pages/${handle}"]`).forEach(el => {
      let wrapper = el.closest("li, div, section, article, p");
      if (wrapper) wrapper.remove();
      else el.remove();
    });
  });

  if (
    document.querySelector('form[action*="/search"]') ||
    document.body.className.includes('template-search')
  ) {
    hiddenHandles.forEach(handle => {
      document.querySelectorAll(`[href*="/pages/${handle}"]`).forEach(el => {
        let container = el.closest("li, div, section, article, p");
        if (container) container.remove();
        else el.remove();
      });
    });
  }
});
